import { Stack } from '@mui/system'
import {
  EngagementQuickClearedOutdoorActivityResultType,
  MonitoringSpecialistTriageOutdoorActivity,
  ProcessedActivity
} from '../../../../../../api/models'
import { FIELD_LABEL_RESOLUTION_CATEGORY } from '../ActivityCard.constants'
import { ActivityFieldBox } from '../ActivityFieldBox'
import { SharedActivity, SharedActivityProps } from './SharedActivity'
import type { FC } from 'react'
import { camelCaseToSplitWords } from '../../../activityUtils'

type MonitoringSpecialistTriageActivityProps = SharedActivityProps & {
  activity: Extract<ProcessedActivity, MonitoringSpecialistTriageOutdoorActivity>
}

export const MonitoringSpecialistTriageActivity: FC<MonitoringSpecialistTriageActivityProps> = ({ activity, ...props }) => {
  /**
   * MonitoringSpecialistTriageOutdoorActivity.completed.result is a union but only one of the members
   * has a "category" field: EngagementQuickClearedOutdoorActivityResult
   */
  const quickClearCategory =
    activity.completed?.result?.type === EngagementQuickClearedOutdoorActivityResultType.EngagementQuickCleared
      ? activity.completed.result.category
      : undefined

  return (
    <Stack direction="column" useFlexGap sx={{ gap: 'var(--spacing-2xs)' }}>
      <SharedActivity {...props} activity={activity} />
      {quickClearCategory && (
        <ActivityFieldBox label={FIELD_LABEL_RESOLUTION_CATEGORY} labelTestId="activity-card-resolution-category">
          {camelCaseToSplitWords(quickClearCategory)}
        </ActivityFieldBox>
      )}
    </Stack>
  )
}
